import Skeleton from 'react-loading-skeleton';
import S from './SpacesPageSkeleton.module.scss';
export const PlanPageSkeleton = () => {
  return <div className={S.layout} data-sentry-component="PlanPageSkeleton" data-sentry-source-file="PlanPageSkeleton.tsx">
      <div className={S.column}>
        <Skeleton width={150} height={28} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
        <Skeleton width={100} inline height={22} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
        <Skeleton width={100} inline height={22} style={{
        marginLeft: '5px'
      }} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
        <div className={S.tablet} style={{
        display: 'flex',
        marginTop: '50px'
      }}>
          <aside className={S.aside}>
            <Skeleton width={130} height={28} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
            <Skeleton width={130} height={28} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
            <Skeleton width={130} height={28} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
          </aside>
          <main className={S.main}>
            <Skeleton width={200} height={28} style={{
            marginBottom: '50px'
          }} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
            <div style={{
            display: 'flex',
            gap: '80px'
          }}>
              <div className={S.mo_sub_tab}>
                <Skeleton width={150} height={20} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
                <Skeleton width={150} height={20} style={{
                marginTop: '90px'
              }} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
              </div>
              <div>
                <Skeleton width={350} height={20} count={7} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
              </div>
            </div>
            <Skeleton width={200} height={28} style={{
            margin: '150px 0 50px'
          }} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
            <div style={{
            display: 'flex',
            gap: '80px'
          }}>
              <div className={S.mo_sub_tab}>
                <Skeleton width={150} height={20} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
                <Skeleton width={150} height={20} style={{
                marginTop: '90px'
              }} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
                <Skeleton width={150} height={20} style={{
                marginTop: '90px'
              }} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
              </div>
              <div>
                <Skeleton width={200} height={20} count={7} data-sentry-element="Skeleton" data-sentry-source-file="PlanPageSkeleton.tsx" />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>;
};